'use strict';

const container = require('./../../core/container');
const jQuery = require('jquery');
const loader = require('./../../services/loader');
const repository = require('./repository/aboutRepository');
const tpl = require('./template/about.card.hbs');
const translator = require('./../../core/translator');
const zone = require('./../../services/structure/zone');

module.exports.init = () => {
  let $panelFullPage = container.get('$toolbar').find('.cloud-panel-fullpage');

  if (!$panelFullPage.hasClass('d-none')) {
    $panelFullPage.addClass('d-none');
  }

  loader.start();

  zone.setSmallPanel(translator.translate('about'), getSmallPanelContent());
  setTimeout(function() {
    zone.setFullPanel(translator.translate('about'), getFullPanelContent());
  }, 100);

  loader.stop();
};

const getSmallPanelContent = () => {
  return `<p>${translator.translate('about_description')}</p>`;
};

const getFullPanelContent = () => {
  let $container = jQuery('<div class="mt-3 about-container"><div id="accordion" /></div>');
  getCardsContent($container);

  return $container;
};

const getCardsContent = (container) => {
  repository.getInformation().done(function(entries) {
    Object.entries(entries).forEach((entry, key) => {
      const [section, values] = entry;
      let $tpl = jQuery(tpl({
        'section': 'about_' + section,
        'key': key,
        'collapse': 'show',
      }));
      let $tplCardBody = $tpl.find('#collapse' + key + ' .card-body').append('<ul />').find('ul');
      if (Array.isArray(values)) {
        values.forEach(function(value) {
          let $listItem = section === 'packages' ? '<b>' + value.description + ' : </b>' + value.version : '<span class="text-capitalize">' + value + '</span>';
          $tplCardBody.append(jQuery(`<li>` + $listItem + `</li>`));
        });
      } else {
        for (const [key, value] of Object.entries(values)) {
          $tplCardBody.append(jQuery(`<li><b>${translator.translate('about_field_' + key)} :</b> ${value}</li>`));
        }
      }
      container.append($tpl);
    });
  });

  return container;
};
